import React, { useEffect, useState } from "react";
import { CheckPicker, Notification, useToaster } from 'rsuite';
import "rsuite/dist/rsuite.css";
import CustomLoader from "../../comman/Loader/CustomLoader"
import { APIRequest, ApiUrl } from "../../../Helpers/ApiHelper";
import Header from "../../comman/Header-copy";
import Topbar from "../../comman/Topbar";
import List from './List';
import DetailsModal from "./DetailModal";
import SearchBar from "../../comman/Search/SearchBar";
import colourStyles from "../../../Helpers/colourStyles";
import Select from "react-select";
import Footer from "../../comman/Footer";




const AllTasks = () => {

  const [data, setData] = useState([]);
  const [allTaskRequests, setAllTaskRequests] = useState([]);
  const [influncerFliter, setInfluncerFliter] = useState();
  const [campaignFilter, setCampaignFilter] = useState();
  const [reajectReason, setReajectReason] = useState({});
  const [showModal, setShowModal] = useState(false);
  const [selectedTaskRequest, setSelectedTaskRequest] = useState();
  const [isLoading, setIsLoading] = useState(true);
  const [search, setSerach] = useState('');
  const toaster = useToaster();


  useEffect(() => {

    getAllCampaignTasks();
    
    const close = (e) => {
      if (e.keyCode === 27) {
        setShowModal(false);
      }
    }
    window.addEventListener('keydown', close)
    return () => window.removeEventListener('keydown', close)

  }, [])

  const getAllCampaignTasks = () => {
    let confing = {
      url: `${ApiUrl.getAllCampaignTasks}`,
      method: 'GET',
      body: {}
    }

    APIRequest(
      confing,
      res => {
        setIsLoading(false);
        setShowModal(!showModal);
        setData(res?.campaign);
        setInfluncerFliter(res?.influncerFliter);
        setCampaignFilter(res?.campaignFilter);
        setAllTaskRequests(res?.campaign);
      },
      err => {
        setIsLoading(false);
      }
    )
  }


  const updateTaskStatus = (action) => {
    setIsLoading(true);
    let config = {
      url: ApiUrl.updateCampaignTaskRequest,
      method: 'POST',
      body: {
        campaignTaskRequest: selectedTaskRequest?.id,
        reajectReason: reajectReason,
        status: action,
      }
    }
    APIRequest(
      config,
      res => {
        setIsLoading(false);
        toaster.push(<Notification type='success' header="Success"  >{res.message}</Notification>, {
          placement: 'topEnd'
        });
        getAllCampaignTasks();
      },

      err => {
        setIsLoading(false);
        alert('SERVER ERROR');
      }

    )
  }

  const handleRejectReason = (e) => {
    const { name, value } = e.target;
    setReajectReason({
      ...reajectReason,
      [name]: value
    })
  }

  const searchOnChange = (value) => {

    const val = value.toLowerCase();
    const finalVal = data?.filter((v) => (v?.campaign?.campaign_title.toLowerCase()?.includes(val) || v?.influencer_name.toLowerCase().includes(val)));
    setAllTaskRequests(finalVal);
    setSerach(value);
  }



  const handleFilterDropDown = (value, name) => {
    if (name === 'campaign_title') {
      var finalVal = data?.filter((v) => (value?.includes(v?.campaign?.campaign_title)));
    }
    if (name === 'influencer_name') {
      finalVal = data?.filter((v) => (value?.includes(v?.influencer_name)));
    }

    if (finalVal.length > 0) {
      setAllTaskRequests(finalVal);
    } else {
      setAllTaskRequests(data);
    }
  }


  return (
    <>
      <div className="min-h-[100vh]">
        <Header />
        <Topbar />
        <CustomLoader visible={isLoading} />

        <div >
          <div className="md:grid  md:gap-6">
            {!isLoading && (
              <div>
                <SearchBar search={search} title={'My Tasks'} searchOnChange={(value) => searchOnChange(value)} />
                <div className="py-2 flex  items-center my-2 justify-end md:gap-4 ms:container ms:mx-auto px-4 ms:px-0">
                  <p className="font-museobb text-lg md:mr-0 mr-3">Filters</p>
                  <div >
                    {/* <CheckPicker placeholder="Filter by Influencer" onChange={(value) => handleFilterDropDown(value, 'influencer_name')} data={influncerFliter?.map(item => ({ label: item?.name, value: item?.name }))} style={{ 'width': "150px" }} /> */}
                    <Select
                      placeholder="Filter by Influencer"
                      closeMenuOnSelect={false}
                      isMulti
                      className="mt-1 "
                      menuPlacement={"auto"}
                      styles={colourStyles}
                      options={influncerFliter?.map(item => ({ label: item?.name, value: item?.name }))}
                      // defaultValue={formData?.age !== undefined ? formData?.age : []}
                      onChange={(value) => handleFilterDropDown(value, 'influencer_name')}

                    />


                  </div >
                  {/* <div >
                  <CheckPicker placeholder="Filter by Campaign title" onChange={(value) => handleFilterDropDown(value, 'campaign_title')} data={campaignFilter?.map(item => ({ label: item?.campaign_title, value: item?.campaign_title }))} style={{ 'width': "150px" }} />
                </div > */}
                </div>
                <List data={allTaskRequests}
                  campaignInfo={allTaskRequests}
                  onSelectTaskRequest={(item) => { setSelectedTaskRequest(item); setShowModal(true) }}
                />
                {selectedTaskRequest && (
                  <DetailsModal
                    item={selectedTaskRequest}
                    showModal={showModal}
                    setShowModal={() => { setShowModal(!showModal); getAllCampaignTasks(); }}
                    handleRejectReasonChange={(e) => handleRejectReason(e)}
                    onHandleClick={(action) => updateTaskStatus(action)}

                  />
                )}

              </div>
            )}
          </div>



        </div>
      </div>

      
      <Footer colorClass="footerColor" clas="footer2" />
    </>

  
  );
};

export default AllTasks;
